import './Contacto.css';
import HeroContacto from "./subComponents/HeroContacto.jsx";
import BannerUbicacion from "./subComponents/BannerUbicacion.jsx";
import FormularioContacto from "./subComponents/FormularioContacto.jsx";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faInstagram } from '@fortawesome/free-brands-svg-icons';
import { Link } from 'react-router-dom';
import SEO from "../SEO/SEO";

const Contacto = () => {
    return (
        <div className='container-contacto'>
            <SEO
                title="Contacto | Whisky And Co"
                description="Consultas por WhatsApp o en el local. Av. Recta Martinolli 8669, Cordoba, Argentina."
                canonicalPath="/contacto"
            />

            <HeroContacto />

            <div className='contacto-contenido'>
                <div className='row align-items-center g-4'>
                    
                    <div className='col-12'>
                        <FormularioContacto />
                    </div>
                   
                </div>
            </div>

            <BannerUbicacion />
        </div>
    );
}

export default Contacto;
